import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { AssetField } from '@/lib/asset'
import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxGriditem } from './Griditem'
import { GriditemProps } from './Griditem'

interface GriditemBlokProps {
  blok: {
    asset?: AssetField
    asset_align?: 'left' | 'right' | 'center'
    asset_layout?: 'default' | 'small' | 'large' | 'full' | 'xsmall' | 'inline' | 'ssmall'
    asset_width?: number
    title: GriditemProps['title']
    body: SbBlokData[]
    button?: SbBlokData[]
    layout?: any
    tag?: string
    assetBoxShadow?: boolean
    itemBoxShadow?: boolean
    padding?: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
    alignment?: SbBlokData[]
    link?: string | any
    roundedCorners?: boolean
  } & SbBlokData
}

const Griditem: FC<GriditemBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, blok.alignment, blok.padding)

  let asset: {
    filename: string
    alt: string
    layout?: 'default' | 'small' | 'large' | 'full' | 'xsmall' | 'inline' | 'ssmall'
    align?: 'left' | 'right' | 'center'
    id?: string
    width?: number
  } = { filename: '', alt: '', layout: 'default', align: 'left', id: '', width: 0 }

  if (blok.asset) {
    asset = {
      filename: blok.asset.filename,
      alt: blok.asset.alt,
      id: blok.asset.id,
      layout: blok.asset_layout ? blok.asset_layout : 'default',
      align: blok.asset_align ? blok.asset_align : 'left',
      width: blok.asset_width ? blok.asset_width : 0,
    }
  }

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxGriditem
        asset={asset}
        title={blok.title}
        body={
          blok.body &&
          blok.body.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        button={
          blok.button &&
          blok.button.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        link={
          blok.link && blok.link?.cached_url !== '' && blok.link.cached_url !== '/en-nz/'
            ? blok.link
            : ''
        }
        layout={blok.layout}
        assetBoxShadow={blok.assetBoxShadow}
        itemBoxShadow={blok.itemBoxShadow}
        roundedCorners={blok.roundedCorners}
        tag={blok.tag}
        textColor={stylePanel.textColor}
        backgroundColor={stylePanel.backgroundColor}
        padding={stylePanel.padding}
        alignment={stylePanel.alignment as 'left' | 'center' | 'right'}
      />
    </div>
  )
}

export default Griditem
